import { Router } from 'vue-router'
import { Store } from 'vuex'
import { RootState } from '@/store'

export const AUTHORIZED_USER_HOME = '/analysis'

/**
 * An authorized user sees the client's results on their behalf, and nothing else. Each page
 * they may open declares `meta.allowAuthorizedUser`; everything else sends them home.
 *
 * Registered globally rather than on a layout: the restriction is a property of the route, and
 * the pages that skip `defaultLayout` (checkout, onboarding, kit registration) need it just as
 * much as the ones that don't.
 */
export function registerAuthorizedUserGuard(router: Router, store: Store<RootState>): void {
	router.beforeEach(to => {
		const { isLoggedIn, user } = store.state.auth

		if (!isLoggedIn || !user?.has_authorized_user_role) {
			return true
		}

		if (to.meta.allowAuthorizedUser === true) {
			return true
		}

		return AUTHORIZED_USER_HOME
	})
}
